// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"cba0bda3","294":"89fc6a0f","413":"4608bed8","447":"80ceeffb","502":"7364341c","567":"af8ab212"}[chunkId] + ".chunk.css";
};